module.exports = __webpack_public_path__ + "img/logo-dark.d3ed7918.png";